import {FC} from 'react'
import { Manager } from '../../core/_models'

type Props = {
  manager: Manager
}

const ManagerIdCell: FC<Props> = ({manager}) => {
  return (
    <>
      {
        <div className='d-flex align-items-center'>
        <div className='d-flex flex-column'>
            {manager.id}
        </div>
      </div>
      }
    </>
  )
}

export {ManagerIdCell}
